import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {Currency} from "@/modules/redactor/models/currency/Currency";

export class CurrencyFormula extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(CurrencyFormula, v) : SKIP;
        }, (v) => {
            return deserialize(CurrencyFormula, v);
        });
    }

    constructor() {
        super();

        this._name = null;
        this._components = [];
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get components() {
        return this._components;
    }

    set components(value) {
        this._components = value;
    }

    valid() {

        if(!this.name){
            return false;
        }

        if (this.components && this.components.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.components.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CurrencyFormula());
        } else if (target instanceof CurrencyFormula) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CurrencyFormula, {
    _name: alias("name", Schema.primitive()),
    _components: alias("components", list(Currency.schema()))
});